/**
 * kind 等で網羅的に処理すべき箇所において、未処理のケースが残っていたらコンパイルエラーにするためのユーティリティ関数。
 * popopo-lib-common/never.ts からインライン化。
 * popopo-msg は配布パッケージとして外部リポジトリに同期されるため、
 * workspace 依存を避ける必要がある。
 */
export function assertNever(x: never): never {
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  throw new Error(`Unexpected value: ${x}`)
}
